// OpenInApp module removed in ofuro-wiki - no desktop app
export const OpenInAppCard = () => {
  return null;
};
